import React, { useContext, } from 'react';
import {
    FaUser,
    FaCalendarAlt,
    FaEnvelope,
    FaUserCircle,
    FaLink,
    FaCopy,
    FaGlobe,
} from 'react-icons/fa';
import { toast } from 'sonner';
// import { DataContext } from '../../contexts/DataContext';
import { copy } from 'clipboard';
import { DataContext } from 'context/DataContext';
export const ProfileInfo = () => {
    const { profileData } = useContext(DataContext)
    const copyToClipboard = () => {
        copy(
            window.location.origin +
            "/signup?ref_by=" +
            (profileData?.Profile?.UserID ? profileData?.Profile?.UserID : "") +
            ""
        );
        toast.success(
            `You have copied "${window.location.origin +
            "/signup?ref_by=" +
            (profileData?.Profile?.UserID ? profileData?.Profile?.UserID : "") +
            ""
            }"`
        );
    };

    return (
        <div className="py-8">

            <div className="m-3">

                <div className="glass-card  rounded-xl overflow-hidden hover-scale">
                    <div className="bg-zinc-700 p-4">
                        <div className="flex items-center space-x-3">
                            <div className="p-3 bg-white bg-opacity-20 rounded-full">
                                <FaUser className="w-5 h-5 text-white" />
                            </div>
                            <h2 className="text-xl font-semibold text-white">Profile Information</h2>
                        </div>
                    </div>

                    <div className="p-2 lg:p-5">
                        <div className="space-y-4">
                            <div className="flex items-center space-x-3 p-3 bg-gray-800 bg-opacity-40 rounded-lg">
                                <div className="p-2 bg-neonGreenDark bg-opacity-30 rounded-full">
                                    <FaUserCircle className="w-5 h-5 text-neonPurple" />
                                </div>
                                <div>
                                    <p className="text-xs text-white">UserID</p>
                                    <p className="font-medium text-neonPurple">{profileData?.Profile?.UserID}</p>
                                </div>
                            </div>


                            <div className="flex  items-center space-x-3 p-3 bg-gray-800 bg-opacity-40 rounded-lg">
                                <div className="p-2 bg-neonGreenDark bg-opacity-30 rounded-full">
                                    <FaEnvelope className="w-5 h-5 text-neonPurple" />
                                </div>
                                <div className='w-full'>
                                    <p className="text-xs text-white">Email Address</p>
                                    <div className='flex justify-between  w-full  '>
                                        <p className="font-medium text-neonPurple">
                                            {profileData?.Profile?.Email ? (() => {
                                                const email = profileData?.Profile?.Email;
                                                const atIndex = email.indexOf('@');

                                                if (atIndex < 3) return email;

                                                const firstChar = email[0];
                                                const lastCharBeforeAt = email[atIndex - 1];
                                                const stars = '*'.repeat(Math.max(atIndex - 2, 0));
                                                const domain = email.slice(atIndex);

                                                return (
                                                    <>
                                                        <span>{firstChar}</span>
                                                        <span className="font-mono tracking-widest">{stars}</span>
                                                        <span>{lastCharBeforeAt}{domain}</span>
                                                    </>
                                                );
                                            })() : ''}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="flex items-center space-x-3 p-3 bg-gray-800 bg-opacity-40 rounded-lg">
                                <div className="p-2 bg-neonGreenDark bg-opacity-30 rounded-full">
                                    <FaGlobe className="w-5 h-5 text-neonPurple" />
                                </div>
                                <div>
                                    <p className="text-xs text-white">Country</p>
                                    <p className="font-medium text-neonPurple">{profileData?.Profile?.Country}</p>
                                </div>
                            </div>
                            <div className="flex items-center space-x-3 p-3 bg-gray-800 bg-opacity-40 rounded-lg">
                                <div className="p-2 bg-neonGreenDark bg-opacity-30 rounded-full">
                                    <FaCalendarAlt className="w-5 h-5 text-neonPurple" />
                                </div>
                                <div>
                                    <p className="text-xs text-white">Member Since</p>
                                    <p className="font-medium text-neonPurple">{new Date(profileData?.Profile?.Joined).toLocaleDateString('en-US', {
                                        year: 'numeric',
                                        month: 'long',
                                        day: 'numeric'
                                    })}</p>
                                </div>
                            </div>
                            <div className="grid gap-2 grid-cols-1 mt-1 ">
                                <div className="flex items-center space-x-3 p-3 bg-gray-800 bg-opacity-40 rounded-lg">
                                    <div className="p-2 bg-neonGreenDark bg-opacity-30 rounded-full">
                                        <FaLink className="w-5 h-5 text-neonPurple" />
                                    </div>
                                    <div>
                                        <h3 className="text-xs text-white">
                                            Referral Link
                                        </h3>
                                        <div className="flex flex-wrap lg:flex-nowrap items-center  justify-between w-full lg:gap-5 rounded-md p-1">
                                            <span className="text-white ">
                                                {`${window.location.origin}/signup?ref_by=${profileData?.Profile?.UserID || ""
                                                    }`}
                                            </span>
                                            {profileData?.Profile?.UserID && (
                                                <button
                                                    onClick={copyToClipboard}
                                                    className="text-neonPurple hover:text-neonPurple transition-colors"
                                                >
                                                    <FaCopy size={18} />
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProfileInfo;